import { Injectable } from '@angular/core';

import { AdminLoginResponse, AdminRefreshResponse, AdminUser } from './authentication.service';

@Injectable({ providedIn: 'root' })
export class AdminSessionService {
  private readonly accessTokenStorageKey = 'adminAccessToken';
  private readonly refreshTokenStorageKey = 'adminRefreshToken';
  private readonly userStorageKey = 'adminUser';

  get accessToken(): string | null {
    return localStorage.getItem(this.accessTokenStorageKey);
  }

  set accessToken(token: string | null) {
    this.setStorageValue(this.accessTokenStorageKey, token);
  }

  get refreshToken(): string | null {
    return localStorage.getItem(this.refreshTokenStorageKey);
  }

  set refreshToken(token: string | null) {
    this.setStorageValue(this.refreshTokenStorageKey, token);
  }

  get user(): AdminUser | null {
    const user = localStorage.getItem(this.userStorageKey);
    return user ? JSON.parse(user) as AdminUser : null;
  }

  set user(user: AdminUser | null) {
    if (user == null) {
      localStorage.removeItem(this.userStorageKey);
      return;
    }

    localStorage.setItem(this.userStorageKey, JSON.stringify(user));
  }

  get isAuthenticated(): boolean {
    return Boolean(this.accessToken && this.refreshToken && this.user);
  }

  persistLoginSession(response: AdminLoginResponse): void {
    this.accessToken = response.access;
    this.refreshToken = response.refresh;
    this.user = response.user;
  }

  persistRefreshSession(response: AdminRefreshResponse): void {
    this.accessToken = response.access;
    if (response.refresh) {
      this.refreshToken = response.refresh;
    }
  }

  rehydrateUser(user: AdminUser): void {
    this.user = user;
  }

  clearSession(): void {
    localStorage.removeItem(this.accessTokenStorageKey);
    localStorage.removeItem(this.refreshTokenStorageKey);
    localStorage.removeItem(this.userStorageKey);
  }

  private setStorageValue(key: string, value: string | null): void {
    if (value == null || value === '') {
      localStorage.removeItem(key);
      return;
    }

    localStorage.setItem(key, value);
  }
}
